<div container="body" ngbDropdown placement="bottom-right" role="group">
  <button class="btn btn-primary btn-sm" [disabled]="entries.length === 0" ngbDropdownToggle>
    <ng-template [ngTemplateOutlet]="labelTemplate ?? defaultLabel"></ng-template>
    <ng-template #defaultLabel>{{ label | portalTranslate }}</ng-template>
  </button>

  <div class="dropdown-menu dropdown-menu--bootstrap-default" ngbDropdownMenu>
    <ng-content></ng-content>
  </div>
</div>
